import { useEffect } from "react";
import Footer from "../Footer";
import Header from "../Header";
import AmalfiCoast from "../assets/img/Blogs/Italy/AmalfiCoast.jpg";
import Colosseum from "../assets/img/Blogs/Italy/Colosseum.jpg";
import FlorencesCathedral from "../assets/img/Blogs/Italy/FlorencesCathedral.jpg";
import GondolasInVenice from "../assets/img/Blogs/Italy/GondolasInVenice.jpg";
import MilansCathedral from "../assets/img/Blogs/Italy/MilansCathedral.jpg";

const Italy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header></Header>
      <div className="mainContent blogDtlWrap">
        <div className="blogBannerWrap italyBlogBannerWrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 col-lg-8">
                <div className="bannerDataWrap">
                  <h2>Italy’s Top 5 Must-Visit Places</h2>
                  <p>
                    Italy, a country rich in history, art, and breathtaking
                    landscapes, is one of the most sought-after travel
                    destinations in the world. From ancient ruins to stunning
                    coastal towns, here are the five must-visit places in Italy:
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={Colosseum} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>01.</span>
                  <h2> Rome – The Eternal City</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A historic city filled with iconic landmarks and culture.
                    </p>
                  </div>
                  <p>
                    Rome, the capital of Italy, is a must-see destination for
                    history enthusiasts. The Colosseum, a symbol of ancient
                    Rome, offers a glimpse into gladiatorial battles. The
                    Vatican City, home to St. Peter’s Basilica and the Sistine
                    Chapel, is a spiritual and artistic wonder. Don’t forget to
                    toss a coin into the Trevi Fountain for good luck!
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Colosseum</p>
                    </li>
                    <li>
                      <p>Vatican</p>
                    </li>
                    <li>
                      <p>Trevi Fountain</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={GondolasInVenice} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>02.</span>
                  <h2> Venice – The Floating City</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A magical city built on water, known for romance and
                      history.
                    </p>
                  </div>
                  <p>
                    Venice is a unique and mesmerizing city where canals replace
                    roads. A Gondola ride along the Grand Canal provides
                    stunning views of historic buildings. St. Mark’s Square and
                    its majestic basilica are must-see spots. With its timeless
                    beauty, Venice remains one of the most romantic destinations
                    in the world.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Grand Canal</p>
                    </li>
                    <li>
                      <p>St. Mark’s Square</p>
                    </li>
                    <li>
                      <p>Gondola Rides</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={FlorencesCathedral} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>03.</span>
                  <h2> Florence – The Heart of the Renaissance</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A cultural hub full of art, history, and stunning
                      architecture.
                    </p>
                  </div>
                  <p>
                    Florence is the birthplace of the Renaissance and home to
                    artistic masterpieces. The Uffizi Gallery houses works by
                    Michelangelo and Leonardo da Vinci. The Ponte Vecchio, a
                    historic bridge lined with shops, and the Florence Cathedral
                    (Duomo) with its magnificent dome are must-visit landmarks.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Uffizi Gallery</p>
                    </li>
                    <li>
                      <p>Ponte Vecchio</p>
                    </li>
                    <li>
                      <p>Duomo</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={MilansCathedral} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>04.</span>
                  <h2>Milan – A Blend of Fashion and History</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>A stylish metropolis with stunning architecture.</p>
                  </div>
                  <p>
                    Milan is Italy’s fashion and financial capital, but it also
                    boasts remarkable historical sites. The Duomo di Milano, a
                    grand gothic cathedral, offers breathtaking city views from
                    its rooftop. The Galleria Vittorio Emanuele II, an elegant
                    shopping arcade, is a paradise for fashion lovers.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Duomo di Milano</p>
                    </li>
                    <li>
                      <p>Galleria Vittorio Emanuele II</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction blogTopAttractionPadBtm">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={AmalfiCoast} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>05.</span>
                  <h2>Amalfi Coast – A Coastal Paradise</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Breathtaking cliffs, colorful towns, and stunning views.
                    </p>
                  </div>
                  <p>
                    The Amalfi Coast is one of the most picturesque coastlines
                    in the world. Positano is famous for its pastel-colored
                    houses and beautiful beaches. Ravello offers stunning
                    gardens and panoramic views. Driving along the coastal roads
                    provides unforgettable scenery.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Positano</p>
                    </li>
                    <li>
                      <p>Ravello</p>
                    </li>
                    <li>
                      <p>Coastal Drives</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="finalThouthWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Final Thoughts</h2>
                <p>
                  Italy offers a diverse mix of history, art, and natural
                  beauty. Whether you explore the ancient ruins of Rome, glide
                  through the canals of Venice, or relax on the Amalfi Coast,
                  each destination has something special to offer.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="styConnectedWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="styConnectedBox">
                  <div className="imgWrap">
                    <img src={Colosseum} className="img-fluid" alt="" />
                  </div>
                  <div className="dataWrap">
                    <h2> Start planning your Italian getaway today! </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default Italy;
